<div class="mb-56 !pb-0 content white" [class.view-only]="isViewOnly" [class.hidden]="!isLoading && !dataSource.data.length && !isFilterOrSearchActive">
    <div
        class="pt-24"
        [class.px-24]="parentType === TeamCertificationParentNameEnum.Admin"
        *ngIf="parentType !== TeamCertificationParentNameEnum.Replace"
        [class.hidden]="isLoading"
    >
        <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            class="mb-12 px-16 pt-8"
            *ngIf="parentType === TeamCertificationParentNameEnum.Profile || parentType === TeamCertificationParentNameEnum.UserProfile; else defaultHeader"
        >
            <app-search-outline [searchInput]="searchInput" class="!hidden sm:!block"></app-search-outline>

            <div class="header-actions" fxLayoutAlign="flex-start center">
                <mat-form-field class="mr-16 w-220 relative !hidden sm:!block">
                    <mat-label>{{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.FILTER_BY_STATUS' | translate }}</mat-label>
                    <mat-select [formControl]="statusInput" multiple>
                        <mat-option *ngFor="let status of certificatesStatuses" [value]="status.value">{{ status.translationLabel | translate }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <app-flat-button
                    [icon]="'add_circle'"
                    [label]="'PAGE.CERTIFICATE.BUTTON.ADD'"
                    (onClick)="openAddCertificateDialog()"
                    *ngIf="canUserManageCertificates && isAddCertificateBtnVisible"
                ></app-flat-button>
            </div>
        </div>
        <ng-template #defaultHeader>
            <div class="header" fxLayoutAlign="space-between center">
                <div fxLayoutAlign="flex-start center">
                    <app-search-outline class="mr-8" [searchInput]="searchInput"></app-search-outline>
                    <app-white-button
                        [svgIcon]="'filter_by'"
                        [label]="'GENERAL.PROPERTY.FILTER_BY'"
                        [counter]="filtersList.length || null"
                        class="mr-8"
                        (click)="openFilterByDialog()"
                    ></app-white-button>
                    <app-white-button [label]="'GENERAL.LABEL.CLEAR_FILTERS'" (click)="clearFilters()" *ngIf="filtersList.length"> </app-white-button>
                </div>

                <div class="header-actions" fxLayoutAlign="flex-start center">
                    <mat-slide-toggle class="mr-8" [formControl]="subteamsProgressToggle" (change)="subteamsProgressToggleChanged($event)" *ngIf="teamId && subteamCount">
                        {{ 'TEAMS.TEAM_PROGRESS.LABEL.INCLUDE_SUBTEAMS_PROGRESS' | translate }}
                    </mat-slide-toggle>
                    <app-white-button
                        [icon]="'download'"
                        [label]="'GENERAL.BUTTON.DOWNLOAD_EXCEL'"
                        class="mr-8"
                        (onClick)="downloadExcel()"
                        *ngIf="isDownloadButtonVisible"
                    ></app-white-button>
                    <app-flat-button
                        [icon]="'add_circle'"
                        [label]="'PAGE.CERTIFICATE.BUTTON.ADD'"
                        class="mr-8"
                        (onClick)="openAddCertificateDialog()"
                        *ngIf="canUserManageCertificates && isAddCertificateBtnVisible"
                    ></app-flat-button>

                    <button
                        mat-raised-button
                        class="mat-elevation-z0 accent"
                        fxLayout="row"
                        [matMenuTriggerFor]="moreMenu"
                        aria-label="More"
                        *ngIf="parentType === TeamCertificationParentNameEnum.Admin || parentType === TeamCertificationParentNameEnum.Team"
                    >
                        <span>
                            {{ selectedUserIds.length || (userIds$ | async)?.length || 0 }}
                            {{ 'GENERAL.LABEL.USER' | translate: { total: selectedUserIds.length || (userIds$ | async)?.length } }}
                        </span>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>

                    <mat-menu #moreMenu="matMenu" xPosition="before">
                        <app-menu-item-button
                            [svgIcon]="'notify'"
                            [label]="'GENERAL.BUTTON.NOTIFY'"
                            (onClick)="openNotifyDialog('selected')"
                            [showThreeDots]="true"
                            [disabled]="hasNoUsers"
                        ></app-menu-item-button>

                        <app-menu-item-button
                            [icon]="'school'"
                            [label]="'PROGRAM_OFFERING.BUTTON.BOOK_INTO_COURSE'"
                            (onClick)="takeOverSelected()"
                            [showThreeDots]="true"
                            [disabled]="hasNoUsers"
                            *ngIf="parentType === TeamCertificationParentNameEnum.Admin && hasTenantAdminOrUsersReadPermission"
                        ></app-menu-item-button>

                        <app-menu-item-button
                            [svgIcon]="'assign_user_to_audience'"
                            [label]="'PROGRAM_OFFERING.BUTTON.BOOK_INTO_AUDIENCE'"
                            (onClick)="assignUsersToAudience()"
                            [showThreeDots]="true"
                            [disabled]="hasNoUsers"
                            *ngIf="parentType === TeamCertificationParentNameEnum.Admin && hasTenantAdminOrEditGrowPermission"
                        ></app-menu-item-button>
                    </mat-menu>
                </div>
            </div>
            <div class="py-24" fxLayoutAlign="flex-start center">
                <mat-checkbox class="mr-20" [(ngModel)]="isFilterByExpiringChecked" (change)="loadCertificationProvidersPage(true)">
                    <mat-icon class="mr-8 icon-20" svgIcon="exclamation"></mat-icon>
                    <span>{{ 'PAGE.CERTIFICATIONS.LABEL.FILTER_BY_EXPIRING' | translate }}</span>
                    <span>&nbsp;({{ certificatesStatistics?.expiringCount }})</span>
                </mat-checkbox>
                <mat-checkbox class="mr-20" [(ngModel)]="isFilterByRecentlyExpiredChecked" (change)="loadCertificationProvidersPage(true)">
                    <mat-icon class="mr-8 icon-20" svgIcon="error"></mat-icon>
                    <span>{{ 'PAGE.CERTIFICATIONS.LABEL.FILTER_BY_RECENTLY_EXPIRED' | translate }}</span>
                    <span>&nbsp;({{ certificatesStatistics?.expiredCount }})</span>
                </mat-checkbox>
            </div>
        </ng-template>
    </div>

    <div class="w-100-p table-wrapper" [class.hidden]="isLoading">
        <mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="provider">
                <mat-header-cell class="header-cell-30" *matHeaderCellDef>
                    <span [style.paddingLeft.px]="40"> {{ 'PAGE.CERTIFICATIONS.LABEL.PROVIDER' | translate }} </span>
                </mat-header-cell>
                <mat-cell class="cell-30" *matCellDef="let data">
                    <mat-icon
                        [svgIcon]="data.isCertificationTargetMet === true ? 'checkmark_filled' : data.isCertificationTargetMet === false ? 'checkmark_empty' : null"
                        class="mr-8"
                        [ngClass]="{ 'ml-40': parentType === TeamCertificationParentNameEnum.Admin }"
                        [matTooltip]="
                            data.isCertificationTargetMet === true
                                ? ('PAGE.CERTIFICATIONS.LABEL.TARGET_MET' | translate)
                                : data.isCertificationTargetMet === false
                                ? ('PAGE.CERTIFICATIONS.LABEL.TARGET_NOT_MET' | translate)
                                : null
                        "
                        matTooltipPosition="above"
                        *ngIf="parentType === TeamCertificationParentNameEnum.Admin"
                    ></mat-icon>
                    <span class="font-medium block" [ngClass]="{ 'ml-40': parentType !== TeamCertificationParentNameEnum.Admin }">{{ data.provider }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="certificationName">
                <mat-header-cell *matHeaderCellDef>{{ 'PAGE.CERTIFICATIONS.LABEL.CERTIFICATION' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let data" fxLayout="column" fxLayoutAlign="flex-start baseline">
                    <div class="font-medium mb-4 w-100-p h-full" fxLayoutAlign="flex-start center" *ngIf="data.certificationName">
                        <span class="text-ellipsis whitespace-nowrap overflow-hidden" [matTooltip]="data.certificationName" matTooltipPosition="above">
                            {{ data.certificationName }}</span
                        >
                        <span *ngIf="parentType === TeamCertificationParentNameEnum.Admin">&nbsp;({{ data.certificatesCount }})</span>
                    </div>
                    <span
                        [style.color]="data.targetCount > data.certificatesCount ? '#B9493D' : null"
                        *ngIf="data.targetCount && parentType === TeamCertificationParentNameEnum.Admin"
                        >{{ 'GENERAL.LABEL.TARGET' | translate }}: {{ data.targetCount }}</span
                    >
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="checkbox">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    <ng-container *ngIf="data.level === 2">
                        <mat-checkbox [(ngModel)]="checkboxes[data.id]" (change)="onSelectedChange($event, data)" (click)="$event.stopPropagation()"> </mat-checkbox>
                    </ng-container>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let data" [class.disabled]="data.expirationDate | certificationExpirationDisabled">
                    <div class="user-details-card-container">
                        <div class="relative" #avatarCell *ngIf="data.name">
                            <img class="avatar pointer" *ngIf="data.avatarUrl; else initials" [alt]="data.name" [src]="data.avatarUrl" />
                            <ng-template #initials>
                                <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ data.name | initials }}</div>
                            </ng-template>
                        </div>
                    </div>
                    <span>{{ data.name }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>{{ 'GENERAL.PROPERTY.STATUS' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let data" [class.disabled]="data.expirationDate | certificationExpirationDisabled">{{ data.status | translate }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="issueDate">
                <mat-header-cell *matHeaderCellDef>{{ 'PAGE.CERTIFICATIONS.LABEL.ISSUE_DATE' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let data" [class.disabled]="data.expirationDate | certificationExpirationDisabled">{{ data.issueDate | date: 'shortDate' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="expirationDate">
                <mat-header-cell *matHeaderCellDef>{{ 'PAGE.CERTIFICATIONS.LABEL.EXPIRATION_DATE' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let data" [class.disabled]="data.expirationDate | certificationExpirationDisabled">
                    <ng-container *ngIf="data.expirationDate">
                        <span [style.color]="data.expirationDate | certificationExpirationColor">{{ data.expirationDate | date: 'shortDate' }}</span>
                        <mat-icon class="ml-4 icon-20" [svgIcon]="data.expirationDate | certificationExpirationIcon"></mat-icon>
                    </ng-container>
                    <span *ngIf="!data.expirationDate && data.level === 2">-</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef [class.pr-24]="parentType === TeamCertificationParentNameEnum.Replace"></mat-header-cell>
                <mat-cell *matCellDef="let data" [class.pr-24]="parentType === TeamCertificationParentNameEnum.Replace">
                    <ng-container *ngIf="data.level === 2">
                        <div fxFlex="row" fxLayoutAlign="end center" *ngIf="parentType !== TeamCertificationParentNameEnum.Replace; else replaceButtons">
                            <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
                                <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                            </button>

                            <mat-menu #moreMenu="matMenu" xPosition="before">
                                <button mat-menu-item aria-label="edit" (click)="openEditCertificateDialog(data)" *ngIf="!data.isModuleCertificate && canUserManageCertificates">
                                    <mat-icon class="mr-8">edit</mat-icon>
                                    <span>{{ 'GENERAL.BUTTON.EDIT' | translate }}</span>
                                </button>
                                <button mat-menu-item aria-label="edit" (click)="openAddReplaceCertificateDefaultDialog(data)" *ngIf="canUserManageCertificates">
                                    <mat-icon class="mr-8" svgIcon="replace"></mat-icon>
                                    <span>{{ 'GENERAL.BUTTON.REPLACE' | translate }}</span>
                                </button>
                                <button mat-menu-item aria-label="edit" (click)="downloadCertificate(data)" *ngIf="data.filename">
                                    <mat-icon class="mr-8" svgIcon="download"></mat-icon>
                                    <span>{{ 'GENERAL.BUTTON.DOWNLOAD' | translate }}</span>
                                </button>
                                <button mat-menu-item aria-label="remove" (click)="removeCertificate(data)" *ngIf="canUserManageCertificates">
                                    <mat-icon class="mr-8">delete</mat-icon>
                                    <span>{{ 'GENERAL.BUTTON.REMOVE' | translate }}</span>
                                </button>
                                <button mat-menu-item aria-label="no option available" *ngIf="!canUserManageCertificates && !data.filename">
                                    <span>{{ 'GENERAL.LABEL.NO_ACTIONS' | translate }}</span>
                                </button>
                            </mat-menu>
                        </div>
                        <ng-template #replaceButtons>
                            <div fxFlex="row" fxLayoutAlign="end center">
                                <app-flat-button
                                    [label]="'GENERAL.BUTTON.SELECT'"
                                    (click)="toggleCertificateSelection(data); $event.stopPropagation()"
                                    [disabled]="selectedCertificate"
                                    *ngIf="data.id !== selectedCertificate?.id; else unselect"
                                ></app-flat-button>
                                <ng-template #unselect>
                                    <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (click)="toggleCertificateSelection(); $event.stopPropagation()"></app-white-button>
                                </ng-template>
                            </div>
                        </ng-template>
                    </ng-container>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row
                *matRowDef="let row; columns: displayedColumns"
                [ngClass]="{
                    'row-grey': row.level === 0,
                    'off-white': row.level === 1,
                    pointer: row.level === 2,
                    certificate: row.level === 2
                }"
                (click)="row.level === 2 ? openEditCertificateDialog(row) : null"
            ></mat-row>
        </mat-table>

        <mat-paginator
            [persistPageSize]="sessionStorageListPageSize || 'certification-provider.providers-all-list'"
            [length]="certificationProvidersTotalCount$ | async"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 25, 50]"
        ></mat-paginator>
    </div>

    <div class="white" fxLayout="column" fxLayoutAlign="center center" *ngIf="isLoading">
        <div class="shimmer-container min-w-full p-0">
            <div class="shimmer p-12 pb-24">
                <div class="shimmer-card !max-w-full table h-480 animate"></div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="!isLoading && !dataSource.data.length && !isFilterOrSearchActive">
    <div class="w-100-p" fxLayoutAlign="flex-end center" *ngIf="teamId && subteamCount">
        <mat-slide-toggle class="m-16 mb-0" [formControl]="subteamsProgressToggle" (change)="subteamsProgressToggleChanged($event)">
            {{ 'TEAMS.TEAM_PROGRESS.LABEL.INCLUDE_SUBTEAMS_PROGRESS' | translate }}
        </mat-slide-toggle>
    </div>
    <div class="no-options-wrapper m-16" [class.white]="parentType === TeamCertificationParentNameEnum.Profile" fxLayoutAlign="center center">
        <div class="empty-state-container-modern pt-0" fxLayout="column">
            <div fxLayout="column" fxLayoutAlign="center center">
                <mat-icon svgIcon="certificate_illustration" class="participant-view-illustration"></mat-icon>
                <h3>
                    {{
                        (parentType === TeamCertificationParentNameEnum.Profile
                            ? 'PAGE.CERTIFICATIONS.LABEL.NO_CERTIFICATION'
                            : 'PAGE.CERTIFICATION_PROVIDER.LABEL.NO_CERTIFICATES'
                        ) | translate
                    }}
                </h3>

                <app-flat-button
                    [icon]="'add'"
                    [label]="'PAGE.CERTIFICATE.BUTTON.ADD'"
                    (onClick)="openAddCertificateDialog()"
                    class="mt-16"
                    *ngIf="!isViewOnly && canUserManageCertificates && isAddCertificateBtnVisible"
                ></app-flat-button>
            </div>
        </div>
    </div>
</ng-container>
